import { useTranslation } from "react-i18next";
import { MessageId } from "../lib";
import { hasValue, isNullish } from "../lib/util/common-util";

/**
 * @internal
 */
export function useMessageDictionary(): (
  messageId: MessageId | null | undefined,
  interpolation?: { [key: string]: any },
) => string | undefined {
  const { t } = useTranslation();
  return (
    messageId: MessageId | null | undefined,
    interpolation?: { [key: string]: any },
  ) => {
    if (isNullish(messageId)) return undefined;
    if (hasValue(interpolation))
      return t(messageId.value, interpolation) ?? undefined;
    else return t(messageId.value) ?? undefined;
  };
}

/**
 * @internal
 */
export function useErrorMessageDictionary(): (
  messageId: MessageId | null | undefined,
  interpolation?: { [key: string]: any },
) => string | undefined {
  const { t } = useTranslation("commonValidation");
  return (
    messageId: MessageId | null | undefined,
    interpolation?: { [key: string]: any },
  ) => {
    if (isNullish(messageId)) return undefined;
    if (hasValue(interpolation))
      return t(messageId.value, interpolation) ?? undefined;
    else return t(messageId.value) ?? undefined;
  };
}
